import { tabDataFixedIncome, tabData, tabDataEquity, } from "@frameworks/NCD/Constants/constant";
import { ESubProductIds } from "@frameworks/shared-library/components/Orderbook/common/OrderbookConstants";
export var useGoToProductBouquet = function (subCategoryId, navigate) {
    switch (subCategoryId) {
        case ESubProductIds.NCD:
            return navigate("/dashboard/product-bouquet", {
                state: {
                    select: {
                        label: "Fixed Income",
                        value: "54",
                        mfL3LevelData: tabDataFixedIncome,
                    },
                    tabId: subCategoryId,
                    productName: { label: "Wealth Product", value: "Wealth Product" },
                },
            });
        case ESubProductIds.StructuredProducts:
            return navigate("/dashboard/product-bouquet", {
                state: {
                    select: {
                        label: "Managed Portfolio",
                        value: "56",
                        mfL3LevelData: tabData,
                    },
                    tabId: subCategoryId,
                    productName: { label: "Wealth Product", value: "Wealth Product" },
                },
            });
        case ESubProductIds.Bonds:
            return navigate("/dashboard/product-bouquet", {
                state: {
                    select: {
                        label: "Fixed Income",
                        value: "54",
                        mfL3LevelData: tabDataFixedIncome,
                    },
                    tabId: subCategoryId,
                    productName: { label: "Wealth Product", value: "Wealth Product" },
                },
            });
        case ESubProductIds.UnlistedShares:
            return navigate("/dashboard/product-bouquet", {
                state: {
                    select: {
                        label: "Equity",
                        value: "61",
                        mfL3LevelData: tabDataEquity,
                    },
                    tabId: subCategoryId,
                    productName: { label: "Equity and more", value: "Equity and more" },
                },
            });
    }
};
